import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@common/directives/directives.module';
import { LayoutModule } from '@common/layout/layout.module';
import { LayoutService } from '@common/services/layout.service';
import { UIModule } from '@common/UI/UI.module';
import { CoreModule } from '@core/core.module';
import { SynchronizationService } from '@core/services/synchronization.service';
import { UsersService } from '@core/services/users.service';
import { ApiService } from '@services/api.service';
import { ConfigsModule } from './configs/configs.module';
import { DebtsModule } from './debts/debts.module';
import { DiscountsModule } from './discounts/discounts.module';
import { GoodsModule } from './goods/goods.module';
import { HomeComponent } from './home/home.component';
import { InvoicesModule } from './invoices/invoices.module';
import { LoginComponent } from './login/login.component';
import { OrdersModule } from './orders/orders.module';
import { PaymentsModule } from './payments/payments.module';
import { ReportsModule } from './reports/reports.module';
import { routes } from './routes';

const heading = { heading: true };

@NgModule({
  imports: [
    RouterModule.forRoot(routes),

    LayoutModule,
    CoreModule,
    CommonModule,
    UIModule,
    DirectivesModule,

    OrdersModule,
    InvoicesModule,
    PaymentsModule,
    DebtsModule,
    GoodsModule,
    DiscountsModule,

    ConfigsModule,
    ReportsModule
  ],
  declarations: [
  
    HomeComponent,
    LoginComponent,
  ],

  exports: [
    RouterModule
  ],

  providers: [
    ApiService
  ],
})
export class RoutesModule {

  constructor(
    private layout: LayoutService,
    private api: ApiService,
    private sync: SynchronizationService,
    private users: UsersService) {

    this.sync.when(UsersService).commit(() => {

      const home = {
        text: 'Bảng giá hàng hóa',
        link: '/home',
        icon: 'fa fa-info-circle',
        condition: () => true
      };

      const orders_exports = {
        text: 'Khách đặt hàng',
        link: '/orders/exports',
        icon: 'fa fa-file-upload',
        condition: () => this.users.current && this.users.current.Roles.containsAny('Owner', 'Sale')
      };

      const orders_imports = {
        text: 'Chốt hàng đặt xưởng',
        link: '/orders/imports',
        icon: 'fa fa-file-download',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Admin")
      };

      const orders_prices = {
        text: 'Chốt giá đặt xưởng',
        link: '/orders/prices',
        icon: 'fa fa-file-check',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Admin")
      };

      const invoices_imports = {
        text: 'Lên đơn hàng về',
        link: '/invoices/imports',
        icon: 'fa fa-plus-circle',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Accountant")
      };

      const invoices_verification = {
        text: 'Nhận đơn hàng về',
        link: '/invoices/verification',
        icon: 'fa fa-check-circle',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Warehouse")
      };

      const invoices_exports = {
        text: 'Xuất hàng cho khách',
        link: '/invoices/exports',
        icon: 'fa fa-arrow-circle-up',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Warehouse")
      };

      const invoices_returns = {
        text: 'Nhập hàng khách trả',
        link: '/invoices/returns',
        icon: 'fa fa-arrow-circle-down',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Warehouse")
      };

      const invoices_losses = {
        text: 'Xử lý hàng mất',
        link: '/invoices/losses',
        icon: 'fa fa-times-circle',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Warehouse")
      };

      const discounts = {
        text: 'Khấu trừ hàng lỗi',
        link: '/discounts',
        icon: 'fa fa-minus-circle',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Accountant")
      }

      const goods = {
        text: 'Hàng tồn kho',
        link: '/goods',
        icon: 'fa fa-boxes',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Warehouse")
      }

      const payments_debts = {
        text: 'Công nợ',
        link: '/debts',
        icon: 'fa fa-exclamation-circle',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Accountant")
      };

      const payments_services = {
        text: 'Thu chi dịch vụ',
        link: '/payments/services',
        icon: 'fa fa-person-dolly',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Accountant")
      };

      const configs = {
        text: 'Cấu hình',
        link: '/configs',
        icon: 'fa fa-cog',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Admin")
      };

      const reports = {
        text: 'Báo cáo',
        link: '/reports',
        icon: 'fa fa-chart-pie',
        condition: () => this.users.current && this.users.current.Roles.containsAny("Owner", "Accountant", "Monitor")
      };

      const logout = {
        text: 'Đăng xuất',
        icon: 'fa fa-power-off',
        link: '#',
        action: () => this.api.logout()
      };

      this.layout.menu = [

        home,

        heading,

        orders_exports,
        orders_imports,

        heading,

        invoices_imports,
        invoices_verification,
        discounts,

        heading,

        goods,
        invoices_exports,
        invoices_returns,
        invoices_losses,

        heading,

        payments_debts,
        payments_services,

        heading,

        reports,

        heading,

        configs,

        heading,

        logout
      ];
    });;
  }
}
